/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Trial_Mode_SuffixInputs */



/**
* | output |
* | --- |
* | "TRIAL MODE" |
*
* @param {Ccsl_Export_Trial_Mode_SuffixInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_trial_mode_suffix = /** @type {((inputs?: Ccsl_Export_Trial_Mode_SuffixInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Trial_Mode_SuffixInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("MODE ESSAI")
	if (locale === "de") return /** @type {LocalizedString} */ ("TESTMODUS")
	if (locale === "it") return /** @type {LocalizedString} */ ("MODALITÀ DI PROVA")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ПРОБНЫЙ РЕЖИМ")
	if (locale === "es") return /** @type {LocalizedString} */ ("MODO DE PRUEBA")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("试用模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トライアルモード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परीक्षण मोड़")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("MODO DE TESTE")
	return /** @type {LocalizedString} */ ("TRIAL MODE")
});